import { render, staticRenderFns } from "./MassHeaderText.vue?vue&type=template&id=236fcdcf&scoped=true&"
import script from "./MassHeaderText.vue?vue&type=script&lang=js&"
export * from "./MassHeaderText.vue?vue&type=script&lang=js&"
import style0 from "./MassHeaderText.vue?vue&type=style&index=0&id=236fcdcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236fcdcf",
  null
  
)

export default component.exports